<template>
  <section class="container mb-5 mt-5">
    <v-modal ref="modalPapeis" id="modalPapeis" titulo="Escolha seu perfil:" :closeButton="false">
      <div slot="body">
        <div class="list-group pr-4">
          <a
            v-for="papel in papeis"
            href="#"
            class="list-group-item list-group-item-action"
            :key="papel.pk_id_grupo_de_usuario"
            @click.prevent="selecionaPerfil(papel)"><small v-html="papel.descricao_selecao_papel"></small></a>
        </div>
      </div>
    </v-modal>


    <v-modal ref="modalDoisFatores" id="modalDoisFatores" titulo="Autenticação em Dois Fatores:" :closeButton="true"
             :showPicture="false">
      <div slot="body">
        <p style="color:red;" v-if="mensagemCodigoInvalido"><b> O código informado é inválido! </b></p>
        <p style="font-size:16px;"> 1. Escanear o código abaixo no aplicativo Google Authenticator: </p>
        <img :src="linkQrCode" style="width: 200px; height: auto;">
        <p style="font-size:16px;margin-top:20px;"> 2. Informar o código de 6 dígitos gerado: </p>
        <div class="row">
          <fieldset class="col-3 mb-4"></fieldset>
          <v-input-text v-model="codigoDoisFatores" ref="codigoDoisFatores" label="" classe="centralizar"
                        fieldsetClasse="col-6 mb-4"
                        mask="######" @enter="confirmarDoisFatores"/>
        </div>
        <div class="row" v-if="codigoDoisFatores">
          <v-button label="Confirmar Código" @click="confirmarDoisFatores"></v-button>
        </div>
        <br>
      </div>
    </v-modal>

    <v-modal ref="modalDoisFatoresSimples" id="modalDoisFatoresSimples" titulo="Autenticação em Dois Fatores:"
             :closeButton="true" :showPicture="false">
      <div slot="body">
        <p style="color:red;" v-if="mensagemCodigoInvalido"><b> O código informado é inválido! </b></p>
        <p style="font-size:16px;margin-top:20px;"> Informe o código de 6 dígitos gerado no aplicativo Google
          Authenticator: </p>
        <div class="row">
          <fieldset class="col-3 mb-4"></fieldset>
          <v-input-text v-model="codigoDoisFatores" ref="codigoDoisFatores" label="" classe="centralizar"
                        fieldsetClasse="col-6 mb-4"
                        mask="######" @enter="confirmarDoisFatores"/>
        </div>
        <div class="row" v-if="codigoDoisFatores">
          <v-button label="Confirmar Código" @click="confirmarDoisFatores"></v-button>
        </div>
        <br>
      </div>
    </v-modal>

    <v-modal ref="modalDeliberacao" id="modalDeliberacao" titulo="Deliberação">
      <div slot="body">
        <p><small>Foi encontrada deliberações disponíveis para você</small></p>
        <p><small>Deseja vê-las?</small></p>
        <div class="clearfix mb-4"></div>
      </div>
      <div slot="buttons">
        <div class="col">
          <div class="row">
            <v-button label="Sim, me mostre" @click="irParaDeliberacao"/>
            <v-button label="Ir para meu perfil" @click="redirect"/>
          </div>
        </div>
      </div>
    </v-modal>

    <v-modal ref="modalFast" id="modalFast" titulo="ACESSO RÁPIDO">
      <div slot="body">
        <fast-login-modal :serial="checkLogin.serial" @login="login"></fast-login-modal>
      </div>
    </v-modal>

    <v-modal ref="modalErro" id="modalErro" titulo="Ocorreu um Erro" class="alert-danger" ico="ion-alert-circled"
             :showPicture="false" size="30">
      <div slot="body">
        <p v-html="textError"></p>
      </div>
      <div slot="buttons" class="d-block w-100">
        <div class="text-center">
          <button class="button btn rounded-0 button-dark btn-dark" @click="$refs.modalErro.close()">Fechar</button>
        </div>
      </div>
    </v-modal>

    <v-title title="Prosseguir" :show="false"/>

    <div class="col-12">

      <article v-if="checkLogin.serial" class="page pt-3 pb-3">
        <div class="row mb-6">
          <div class="col">
            <div class="row">
              <div class="col-12 col-md-4 ">
              </div>

              <div class="col-12 col-md-4">
                <login-form :serial="checkLogin.serial" @login="login"/>
                <div class="row" style="margin-top:50px;text-align:center;">
                  <v-button v-if="ocultarAcessarUsandoCodigo == false" label="Acessar usando código"
                            @click="abrirModalFast()"
                            css="background: transparent; color: #6d1614; border: none;"></v-button>
                </div>
              </div>

              <div class="col-12 col-md-4">
              </div>
            </div>
          </div>
        </div>
      </article>

      <section class="page pt-3 pb-3">
        <div class="row mb-6">
          <div class="col">
            <div class="row">
              <div class="col-12 col-md-4 ">
              </div>
              <div class="col-12 col-md-8 ">
                <p><a href="/autenticacao/filiacao"> Gostaria de se filiar agora ao PCDoB? Clique aqui</a></p>
                <p v-if="ocultarLinkDeFiliadoSemAcesso == false"><a href="/autenticacao/dados-de-acesso"> É filiado e
                  não tem os dados de acesso? Obtenha aqui</a></p>
              </div>
            </div>
          </div>
        </div>

      </section>

      <campanha-vigente/>
    </div>
  </section>
</template>

<script>
import LoginForm from './Autenticacao/LoginForm.vue'

import FastLoginModal from './Autenticacao/FastLoginModal.vue'
import SocialLogin from './Autenticacao/SocialLogin.vue'
import CampanhaVigente from './CampanhaVigente.vue'

export default {
  components: {
    LoginForm,
    SocialLogin,
    CampanhaVigente,
    FastLoginModal,
  },
  data() {
    return {
      checkLogin: {
        serial: null
      },
      loginTemp: {
        username: null,
        password: null,
        serial: null,
        grant_type: "password",
        temp: 1,
      },
      data: null,
      textError: null,
      papeis: [],
      papelSelecionado: 0,
      grupo: 0,
      irAgenda: null,
      ocultarAcessarUsandoCodigo: true,
      ocultarLinkDeFiliadoSemAcesso: true,
      linkQrCode: '',
      fkIdAutenticacao: null,
      codigoDoisFatores: null,
      mensagemCodigoInvalido: false,
    }
  },
  computed: {
    user_login: function () {
      return this.$route.query.user_login
    },
    temp_senha: function () {
      return this.$route.query.temp_senha
    },
  },
  methods: {
    redirect() {
      let params = this.$root.getQueryParams()
      if (params.hasOwnProperty('return') && params.return != "") {
        location.href = decodeURIComponent(params.return)
      } else {
        this.$root.redirectAuthenticated(false, this.papelSelecionado)
      }
    },
    abrirModalFast() {
      this.$refs.modalFast.show()
    },
    login(data) {
      if (data.hasOwnProperty('papeis')) {
        this.papeis = data.papeis
        this.data = data.usuario
        if (_.size(this.papeis) == 1) {
          this.papelSelecionado = this.papeis[0].pk_id_relaciona_usuario_grupo_de_usuario
          this.grupo = this.papeis[0].fk_id_grupo_de_usuario
          this.data.papel = this.papelSelecionado
          this.data.fk_id_grupo_de_usuario = this.grupo
          this.fazerLogin()
        } else {
          this.$refs.modalPapeis.show()
        }
      } else {
        this.data = data
        this.papelSelecionado = this.data.hasOwnProperty('papel') ? this.data.papel : 0
        this.grupo = this.data.hasOwnProperty('fk_id_grupo_de_usuario') ? this.data.fk_id_grupo_de_usuario : 0
        this.fazerLogin()
      }
    },
    fazerLogin() {
      localStorage.setItem('token', this.data.access_token)
      this.$resources.DoisFatores.get('?fk_id_grupo_de_usuario=' + this.grupo).then((response) => {
        localStorage.setItem('token', null)
        let autenticacaoDoisFatores = response.data.data

        if (autenticacaoDoisFatores) {
          if (autenticacaoDoisFatores.autenticacao_dois_fatores == false) {
            this.executarLogin()
          }

          if (autenticacaoDoisFatores.autenticacao_dois_fatores == true) {
            this.irAutenticacaoDoisFatores(autenticacaoDoisFatores)
          }
        } else {
          this.executarLogin()
        }
      }).catch((error) => {
        console.dir(error)
      })

    },
    confirmarDoisFatores() {
      localStorage.setItem('token', this.data.access_token)
      localStorage.setItem('codigo_autenticacao', this.codigoDoisFatores)
      this.$resources.CodigoDoisFatores.get('?codigo=' + this.codigoDoisFatores + '&pk_id_autenticacao=' + this.fkIdAutenticacao).then((response) => {
        localStorage.setItem('token', null)
        let codigoValido = response.data.data.codigo_valido
        if (codigoValido) {
          this.executarLogin()
        } else {
          alert('O código informado é inválido!')
          this.mensagemCodigoInvalido = true
        }
      }).catch((error) => {
        console.dir(error)
      })
    },
    irAutenticacaoDoisFatores(autenticacaoDoisFatores) {
      if (autenticacaoDoisFatores.secret_configurado == false) {
        this.linkQrCode = autenticacaoDoisFatores.qrcode_secret
        this.fkIdAutenticacao = autenticacaoDoisFatores.pk_id_autenticacao
        this.$refs.modalDoisFatores.show()
      } else {
        this.$refs.modalDoisFatoresSimples.show()
      }
      setTimeout(() => {
        this.$refs.codigoDoisFatores.$el.children[0].focus()
      }, 1000)
    },
    executarLogin() {
      localStorage.setItem('grupoUsuario', this.grupo)
      this.$root.setUsuario(this.data, () => {
        this.$refs.modalPapeis.close()
        this.$root.setLoading()

        if (this.irAgenda == '1') {
          location.href = process.env.VUE_APP_ENDPOINT_URL + 'filiados/agenda';
          return;
        }

        if (this.data.hasOwnProperty('tem_deliberacao') && this.data.tem_deliberacao == true) {
          this.$refs.modalDeliberacao.show()
        } else {
          this.redirect()
        }
      })
    },
    selecionaPerfil(papel) {
      this.papelSelecionado = papel.pk_id_relaciona_usuario_grupo_de_usuario
      this.grupo = papel.fk_id_grupo_de_usuario
      this.fazerLogin()
    },
    colabore() {
      location.href = process.env.VUE_APP_ENDPOINT_URL + 'contribuicao'
    },
    filiacao() {
      this.$router.push({name: 'filiacao'})
    },
    irParaDeliberacao() {
      let token = localStorage.getItem('token')
      let refresh_token = localStorage.getItem('refresh_token')
      if (process.env.NODE_ENV == "development") {
        location.href = process.env.VUE_APP_ENDPOINT_URL + 'filiados/deliberacao?token=' + token + '&refresh_token=' + refresh_token
        return
      }
      location.href = process.env.VUE_APP_ENDPOINT_URL + 'filiados/deliberacao'
    },

    autenticarTemporario() {
      this.textError = null
      this.$refs.modalErro.close()
      localStorage.clear()
      this.loginTemp.serial = this.checkLogin.serial
      this.loginTemp.username = this.user_login
      this.loginTemp.password = this.temp_senha
      this.$resources.OAuth.post('/', this.loginTemp).then((response) => {
        this.login(response.data.data)
      }).catch((error) => {
        console.dir(error)
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            this.textError = error.response.data.message
            this.$refs.modalErro.show()
          }
        } else {
          this.textError = 'Ocorreu um erro na solicitação de acesso temporário'
          this.$refs.modalErro.show()
        }
      })
    },

  },
  created() {
    this.irAgenda = localStorage.getItem('ir_agenda')
    this.$root.checkLocal(this.checkLogin, () => {
      if (this.user_login && this.temp_senha) {
        this.autenticarTemporario()
      }
    })
  }
}
</script>

<style>
.centralizar {
  text-align: center;
}


</style>



// WEBPACK FOOTER //
// src/components/Autenticacao.vue